import { render, staticRenderFns } from "./files-table.vue?vue&type=template&id=cb6114b4&scoped=true"
import script from "./files-table.vue?vue&type=script&lang=js"
export * from "./files-table.vue?vue&type=script&lang=js"
import style0 from "./files-table.vue?vue&type=style&index=0&id=cb6114b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6114b4",
  null
  
)

export default component.exports